import React, { useRef, useState, useEffect } from 'react';
import CombinedEditableSection from '../../../../../../components/CombinedEditableSection.comp';
import {
  SlideDescription,
  SlideTitle,
} from '../../../../../styles/LearnTab/slideBase.styles';
import {
  StepBlockContainer,
  StepColumn,
  TitleBox,
  StepTitle,
  StepText,
} from '../../../../../styles/LearnTab/stepBlock.styles';
import { renderTextWithId } from '../common/EditableSlideField.comp';

export const StepBlockSlide = ({
  slide,
  highlightWord,
  isEditMode = false,
  slideEdits = {},
  showEnglishContent = false,
  onSaveEdit,
  onResetEdit,
  onCancelEdit,
}) => {
  const titleRefs = useRef([]);
  const [maxTitleHeight, setMaxTitleHeight] = useState(0);

  useEffect(() => {
    if (!Array.isArray(slide?.SlideContent)) return;
    const heights = titleRefs.current.slice(0, slide.SlideContent.length).map(el => el?.offsetHeight || 0);
    const max = Math.max(0, ...heights);
    if (max !== maxTitleHeight) {
      setMaxTitleHeight(max);
    }
  }, [slide]);

  const isCondensed = Array.isArray(slide?.SlideContent) && slide.SlideContent.length > 3;
  const stepCount = Array.isArray(slide?.SlideContent) ? slide.SlideContent.length : 0;
  const containerStyle = stepCount === 1 ? { justifyContent: 'center' } : {};

  const titleEdit = slideEdits['title'];
  const displayTitle = showEnglishContent 
    ? (titleEdit?.original || slide?.SlideTitle)
    : (titleEdit?.edited || slide?.SlideTitle);

  const textRendererOptions = { slideEdits, showEnglishContent, highlightWord };

  return (
    <SlideDescription>
      {slide?.SlideTitle && (
        <SlideTitle style={{ textAlign: 'center' }}>
          {highlightWord ? highlightWord('title', displayTitle) : displayTitle}
        </SlideTitle>
      )}
      <StepBlockContainer style={containerStyle}>
        {Array.isArray(slide?.SlideContent) &&
          slide.SlideContent.map((step, idx) => (
            <StepColumn key={idx} stepcount={stepCount}>
              {isEditMode ? (
                <CombinedEditableSection
                  slide={{
                    ...slide,
                    SlideTitle: step.Title,
                    SlideContent: step.Text,
                  }}
                  isEditMode={isEditMode}
                  slideEdits={{
                    title: slideEdits[`content_${idx}_title`],
                    content_0: slideEdits[`content_${idx}_text`],
                  }}
                  showEnglishContent={showEnglishContent}
                  onSave={(field, edit) => {
                    if (field === 'title' && onSaveEdit) {
                      onSaveEdit(`content_${idx}_title`, edit);
                    }
                    if (field === 'content_0' && onSaveEdit) {
                      onSaveEdit(`content_${idx}_text`, edit);
                    }
                  }}
                  onReset={(field) => {
                    if (onResetEdit) {
                      onResetEdit(`content_${idx}_${field === 'title' ? 'title' : 'text'}`);
                    }
                  }}
                  onCancel={(field) => {
                    if (onCancelEdit) {
                      onCancelEdit(`content_${idx}_${field === 'title' ? 'title' : 'text'}`);
                    }
                  }}
                  TitleComponent={StepTitle}
                  ContentComponent={StepText}
                  contentExtraProps={{ iscondensed: isCondensed }}
                />
              ) : (
                <>
                  <TitleBox
                    ref={el => (titleRefs.current[idx] = el)}
                    style={{
                      minHeight: maxTitleHeight || 'auto',
                    }}
                  >
                    {renderTextWithId(`content_${idx}_title`, step.Title, StepTitle, { iscondensed: isCondensed }, textRendererOptions)}
                  </TitleBox>
                  {renderTextWithId(`content_${idx}_text`, step.Text, StepText, { iscondensed: isCondensed }, textRendererOptions)}
                </>
              )}
            </StepColumn>
          ))}
      </StepBlockContainer>
    </SlideDescription>
  );
};

export default StepBlockSlide;
